<template>
	<div>
		<a-spin :tip="spinnerLoaderLabel" size="large" :spinning="spinnerLoader">
			<div class="row pt10" v-if="isSuperAdmin">
				<!-- Bloques para NEZA o TODAS (Desglosado) -->
				<template v-if="selectedBranch !== '3'">
					<div class="col-md-3 text-center">
						<div class="card bgGreen border-0">
							<div class="card-body">
								<div class="font-weight-bold">
									<div class="font-size-21 pointer" @click="openModal('refacciones')">Refacciones</div>
									<div class="font-size-18">{{ numeral(totals.pacific_refacciones).format('$0,0.00') }}</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-3 text-center">
						<div class="card bgGreen border-0">
							<div class="card-body">
								<div class="font-weight-bold">
									<div class="font-size-21 pointer" @click="openModal('boutique')">Boutique</div>
									<div class="font-size-18">{{ numeral(totals.pacific_boutique).format('$0,0.00') }}</div>
								</div>
							</div>
						</div>
					</div>
				</template>

				<!-- Bloque para CHALCO (Unificado) -->
				<template v-else>
					<div class="col-md-4 text-center">
						<div class="card bgGreen border-0">
							<div class="card-body">
								<div class="font-weight-bold">
									<div class="font-size-21 pointer" @click="openModal('pacific')">S2R</div>
									<div class="font-size-18">{{ numeral(dashboardGrouped.pacific - canceledTickets.pacific).format('$0,0.00') }}</div>
								</div>
							</div>
						</div>
					</div>
				</template>

				<!-- Bloque RLS (Class dinámico) -->
				<div :class="selectedBranch === '3' ? 'col-md-4 text-center' : 'col-md-3 text-center'">
					<div class="card bgRls border-0">
						<div class="card-body">
							<div class="font-weight-bold">
								<div class="font-size-21 pointer" @click="openModal('rls')">MO</div>
								<div class="font-size-18">{{ numeral(dashboardGrouped.rls).format('$0,0.00') }}</div>
							</div>
						</div>
					</div>
				</div>

				<!-- Bloque CASH (Class dinámico) -->
				<div :class="selectedBranch === '3' ? 'col-md-4 text-center' : 'col-md-3 text-center'">
					<div class="card bg-purple border-0">
						<div class="card-body">
							<div class="font-weight-bold">
								<div class="font-size-21">
									<a-tooltip>
										<template slot="title" v-if="filters.branchOffice.length == 0">
											<div><b>Neza:</b> {{ numeral(totals.sucursal[1] + totals.sucursal[4]).format('$0,0') }}</div>
											<div><b>Chalco:</b> {{ numeral(totals.sucursal[3]).format('$0,0') }}</div>
										</template>
										Cash
									</a-tooltip>
								</div>
								<div class="font-size-18">{{ numeral(dashboardGrouped.panel).format('$0,0') }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-6 text-center" v-if="isSuperAdmin && filters.branchOffice.length == 0" style="color: rgba(0, 0, 0, 0.8980392157)">
					<div class="card border-0" style="background-color: #ffe600">
						<div class="card-body">
							<div class="font-weight-bold">
								<div class="font-size-21">MercadoLibre</div>
								<div class="font-size-18">{{ numeral(totals.dropshipping).format('$0,0.00') }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-6 text-center" v-if="isSuperAdmin && filters.branchOffice.length == 0" style="color: #fff">
					<div class="card border-0" style="background-color: #96bf48">
						<div class="card-body">
							<div class="font-weight-bold">
								<div class="font-size-21">Shopify</div>
								<div class="font-size-18">{{ numeral(totals.shopify).format('$0,0.00') }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-3" v-if="isUserAdmin || user.user_id == 27 || user.user_id == 31">
					<b>Caja</b>
					<a-select placeholder="Todas" :style="{ width: '100%' }" @change="onChangeBranchOffice" v-model="selectedBranch">
						<a-select-option value=""> Todas </a-select-option>
						<a-select-option value="1"> Neza </a-select-option>
						<a-select-option value="3"> Chalco </a-select-option>
					</a-select>
				</div>
				<div class="col-md-3">
					<div>
						<b>Fecha</b>
						<!-- <a-icon type="reload" @click="onResetFilter('defaultDate')" :style="{ fontSize: '14px', color: 'red' }" /> -->
						<a-range-picker
							:inputReadOnly="true"
							style="width: 100%"
							@change="initModule"
							v-model="filters.defaultDate"
							:default-value="filters.defaultDate"
							:value-format="'YYYY-MM-DD'"
							:format="'YYYY-MM-DD'"
						/>
					</div>
				</div>
				<div class="col-md-3">
					<div>
						<b>Método de Pago</b>
						<a-select mode="multiple" placeholder="Todos" :style="{ width: '100%' }" @change="onChangePaymentMethod" v-model="filters.paymentMethod">
							<a-select-option value=""> Todos </a-select-option>
							<a-select-option value="payment_cash"> Efectivo </a-select-option>
							<a-select-option value="payment_bank_terminal"> Tarjeta </a-select-option>
							<a-select-option value="payment_transfer"> Transferencia </a-select-option>
							<a-select-option value="payment_paypal"> PayPal </a-select-option>
							<a-select-option value="payment_mercadopago"> MercadoPago </a-select-option>
						</a-select>
					</div>
				</div>
				<div class="col-md-3 pt20 text-right">
					<a-button class="btn btn-success ml5" icon="reload" @click="initModule" />
				</div>
			</div>

			<a-table
				:columns="columns"
				:dataSource="tickets"
				class="pt20"
				:pagination="false"
				:rowClassName="
					(_record, index) => {
						if (_record.active < 1) {
							return 'bgRed'
						} else {
							if (_record.from_pacific) {
								if (_record.salesman_info) {
									return 'bgYellow'
								} else {
									return 'bgGreen'
								}
							}
							if (_record.from_panel) {
								return 'bg-purple'
							}
							if (_record.from_rls) {
								return 'bgRls'
							}
						}
					}
				"
				v-if="!settings.isMobileView"
			>
				<div slot="id" slot-scope="record">
					{{ record.id }}
					<div v-if="record.service_order">
						<a-tag color="red"> ODS {{ record.service_order }} </a-tag>
					</div>
					<div>
						{{ record.fullName }}
					</div>
				</div>
				<div slot="total" slot-scope="record">
					{{ numeral(record.total).format('$0,0.00') }}
					<div>
						<span v-if="record.payment_cash > 0 && !record.cart">
							<a-tag color="green">
								{{ numeral(record.payment_cash).format('$0,0.00') }}
								<span style="font-size: 8px">
									<img src="resources/images/cash.png" height="20" />
									Efectivo
								</span>
							</a-tag>
							<br />
						</span>
						<span v-else-if="record.payment_cash > 0 && record.cart">
							<a-tag color="green">
								{{ numeral(record.payment_cash).format('$0,0.00') }}
								<span style="font-size: 8px">
									<img src="resources/images/cash.png" height="20" />
									Efectivo
								</span>
							</a-tag>
							<br />
						</span>
						<div v-if="record.payment_bank_terminal > 0">
							<a-tag color="blue">
								{{ numeral(record.payment_bank_terminal).format('$0,0.00') }}
								<span style="font-size: 8px">
									<img src="resources/images/credit-card.png" height="20" />
									Terminal
								</span>
							</a-tag>
							<br />
						</div>
						<span v-if="record.payment_transfer > 0">
							<a-tag color="orange">
								{{ numeral(record.payment_transfer).format('$0,0.00') }}
								<span style="font-size: 8px">
									<img src="resources/images/money-transfer.png" height="20" />
									Transferencias
								</span>
							</a-tag>
							<br />
						</span>
						<span v-if="record.payment_paypal > 0">
							<a-tag color="purple">
								{{ numeral(record.payment_paypal).format('$0,0.00') }}
								<span style="font-size: 8px">
									<img src="resources/images/paypal.png" height="20" />
									PayPal
								</span>
							</a-tag>
							<br />
						</span>
						<span v-if="record.payment_mercadopago > 0">
							<a-tag color="cyan">
								{{ numeral(record.payment_mercadopago).format('$0,0.00') }}
								<span style="font-size: 8px">
									<img src="resources/images/mercadopago.png" height="20" />
									MercadoPago
								</span>
							</a-tag>
							<br />
						</span>
						<span v-if="record.payment_aplazo > 0 && !record.cart">
							<a-tag color="gray" style="color: #000">
								{{ numeral(record.payment_aplazo).format('$0,0.00') }}
								<span style="font-size: 8px">
									<img src="resources/images/cash.png" height="20" />
									Aplazo
								</span>
							</a-tag>
							<br />
						</span>
						<span v-if="getDiscounts(record.id) > 0">
							<a-tag color="red">
								{{ numeral(getDiscounts(record.id)).format('$0,0.00') }}
								<span style="font-size: 8px"> Descuento </span>
							</a-tag>
							<br />
						</span>
					</div>
				</div>
				<div slot="cart" slot-scope="record">
					<div class="text-left">
						<div v-for="(element, index) in record.cart" :key="index">
							<div>
								{{ element.quantity }}x {{ element.product.sku }} - {{ element.product.label }} - {{ numeral(element?.product?.prices?.sale_price).format('$0,0.00') }}
								<span v-if="element.quantity > 1">- ({{ numeral(element.quantity * element?.product?.prices?.sale_price).format('$0,0.00') }})</span>
							</div>
						</div>
					</div>
				</div>

				<div slot="created_at" slot-scope="record">
					<div>{{ moment(record.created_at).tz('America/Mexico_City').format('DD-MM-YYYY') }}</div>
					<div>{{ moment(record.created_at).tz('America/Mexico_City').format('HH:mm:ss') }} hrs.</div>
				</div>
				<div slot="action" slot-scope="record">
					<a-button class="btn btn-success" size="small" icon="printer" @click="onPrintTicket(record)" v-if="record.from_panel || record.from_rls" />
					<div v-else>{{ record.pacific }}</div>
					<div v-if="record.active < 1">CANCELADO</div>
					<div v-if="record.salesman_info">
						<b>{{ record.salesman_info }}</b>
					</div>
					<!-- <a-button class="btn btn-warning ml7" size="small" icon="file-pdf" @click="onBillSale(record.id)" v-if="record.from == 'rls' && !record.billed" /> -->
				</div>
			</a-table>
			<div v-else class="pt20">
				<div class="card border-0" style="margin-bottom: 10px !important" v-for="(record, index) in tickets" :key="index" :class="getRowClass(record)">
					<div class="card-body">
						<div class="fs25">Ticket #{{ record.id }}</div>
						<div><b>Fecha:</b> {{ moment(record.created_at).tz('America/Mexico_City').format('DD-MM-YYYY HH:mm:ss') }} <span style="text-transform: lowercase">hrs.</span></div>

						<div v-if="record.service_order"><b>ODS:</b> {{ record.service_order }}</div>
						<div><b>Cajero:</b> {{ record.fullName }}</div>
						<b>TOTAL:</b> {{ numeral(record.total).format('$0,0.00') }}
						<div>
							<div v-if="record.pacific"><b>PACIFIC:</b> {{ record.pacific }}</div>
							<div v-if="record.active < 1">CANCELADO</div>
							<div v-if="record.salesman_info">
								<b>{{ record.salesman_info }}</b>
							</div>
						</div>
						<div>
							<span v-if="record.payment_cash > 0 && !record.cart">
								<a-tag color="green">
									{{ numeral(record.payment_cash).format('$0,0.00') }}
									<span style="font-size: 8px">
										<img src="resources/images/cash.png" height="20" />
										Efectivo
									</span>
								</a-tag>
								<br />
							</span>
							<span v-else-if="record.payment_cash > 0 && record.cart">
								<a-tag color="green">
									{{ numeral(record.payment_cash).format('$0,0.00') }}
									<span style="font-size: 8px">
										<img src="resources/images/cash.png" height="20" />
										Efectivo
									</span>
								</a-tag>
								<br />
							</span>
							<div v-if="record.payment_bank_terminal > 0">
								<a-tag color="blue">
									{{ numeral(record.payment_bank_terminal).format('$0,0.00') }}
									<span style="font-size: 8px">
										<img src="resources/images/credit-card.png" height="20" />
										Terminal
									</span>
								</a-tag>
								<br />
							</div>
							<span v-if="record.payment_transfer > 0">
								<a-tag color="orange">
									{{ numeral(record.payment_transfer).format('$0,0.00') }}
									<span style="font-size: 8px">
										<img src="resources/images/money-transfer.png" height="20" />
										Transferencias
									</span>
								</a-tag>
								<br />
							</span>
							<span v-if="record.payment_paypal > 0">
								<a-tag color="purple">
									{{ numeral(record.payment_paypal).format('$0,0.00') }}
									<span style="font-size: 8px">
										<img src="resources/images/paypal.png" height="20" />
										PayPal
									</span>
								</a-tag>
								<br />
							</span>
							<span v-if="record.payment_mercadopago > 0">
								<a-tag color="cyan">
									{{ numeral(record.payment_mercadopago).format('$0,0.00') }}
									<span style="font-size: 8px">
										<img src="resources/images/mercadopago.png" height="20" />
										MercadoPago
									</span>
								</a-tag>
								<br />
							</span>
							<span v-if="record.payment_aplazo > 0 && !record.cart">
								<a-tag color="gray" style="color: #000">
									{{ numeral(record.payment_aplazo).format('$0,0.00') }}
									<span style="font-size: 8px">
										<img src="resources/images/cash.png" height="20" />
										Aplazo
									</span>
								</a-tag>
								<br />
							</span>
							<span v-if="getDiscounts(record.id) > 0">
								<a-tag color="red">
									{{ numeral(getDiscounts(record.id)).format('$0,0.00') }}
									<span style="font-size: 8px"> Descuento </span>
								</a-tag>
								<br />
							</span>
						</div>
					</div>
				</div>
			</div>
		</a-spin>
		<ticketComponent
			v-if="ticketVisible"
			:ticketData="ticket.ticketData"
			:advances="ticket.advances"
			:theSalesman="ticket.fullName"
			:cart="ticket.cart"
			:paymentData="ticket.paymentData"
			:hasGiftTicket="giftTicket"
			:serviceOrder="ticket.serviceOrder"
			:orderDiscount="ticket.orderDiscount"
			:client="localClient"
		/>
		<a-modal :visible="modalDetailBoutiqueVisible" :title="`Detalle de ingresos - ${modalType}`" :closable="true" @cancel="onCloseModal('boutique')" width="70%">
			<template slot="footer">
				<a-button key="back" @click="onCloseModal('boutique')"> Cerrar </a-button>
			</template>
			<div class="row">
				<div class="col-md-12 text-center">
					<div class="card bg-primary border-0">
						<div class="card-body">
							<div class="text-white font-weight-bold">
								<div class="font-size-21">Total de Ingresos</div>
								<div class="font-size-18">
									{{ numeral(getModalValue('total')).format('$0,0.00') }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-6 text-center">
					<div class="card bg-success border-0">
						<div class="card-body">
							<div class="text-white font-weight-bold">
								<div class="font-size-21">Efectivo</div>
								<div class="font-size-18">
									{{ numeral(getModalValue('cash')).format('$0,0.00') }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-6 text-center">
					<div class="card bg-info border-0">
						<div class="card-body">
							<div class="text-white font-weight-bold">
								<div class="font-size-21">Digital</div>
								<div class="font-size-18">
									{{ numeral(getModalValue('digital')).format('$0,0.00') }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-12 text-center" v-if="!['refacciones', 'boutique'].includes(modalType)">
					<div class="row">
						<div class="col-md-3 text-center">
							<div class="card bg-info border-0">
								<div class="card-body">
									<div class="text-white font-weight-bold">
										<div class="font-size-21">Terminal Bancaria</div>
										<div class="font-size-18">
											{{ numeral(getNetPaymentMethodValue('credit') + getNetPaymentMethodValue('credit_msi') + getNetPaymentMethodValue('debit')).format('$0,0.00') }}
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-3 text-center">
							<div class="card bg-warning border-0">
								<div class="card-body">
									<div class="text-white font-weight-bold">
										<div class="font-size-21">Terminal Crédito</div>
										<div class="font-size-18">
											{{ numeral(getNetPaymentMethodValue('credit')).format('$0,0.00') }}
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-3 text-center">
							<div class="card bg-warning border-0">
								<div class="card-body">
									<div class="text-white font-weight-bold">
										<div class="font-size-21">Terminal Crédito 3 MSI</div>
										<div class="font-size-18">
											{{ numeral(getNetPaymentMethodValue('credit_msi')).format('$0,0.00') }}
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-3 text-center">
							<div class="card bg-warning border-0">
								<div class="card-body">
									<div class="text-white font-weight-bold">
										<div class="font-size-21">Terminal Débito</div>
										<div class="font-size-18">
											{{ numeral(getNetPaymentMethodValue('debit')).format('$0,0.00') }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-12 text-center" v-else>
					<div class="card bg-info border-0">
						<div class="card-body">
							<div class="text-white font-weight-bold">
								<div class="font-size-21">Terminal Bancaria</div>
								<div class="font-size-18">
									{{ numeral(getModalValue('terminal')).format('$0,0.00') }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="text-center col-md-4">
					<div class="card bg-warning border-0">
						<div class="card-body">
							<div class="text-white font-weight-bold">
								<div class="font-size-21">Transferencia</div>
								<div class="font-size-18">
									{{ numeral(getModalValue('transfer')).format('$0,0.00') }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="text-center col-md-4">
					<div class="card bg-warning border-0">
						<div class="card-body">
							<div class="text-white font-weight-bold">
								<div class="font-size-21">PayPal</div>
								<div class="font-size-18">
									{{ numeral(getModalValue('paypal')).format('$0,0.00') }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="text-center col-md-4">
					<div class="card bg-warning border-0">
						<div class="card-body">
							<div class="text-white font-weight-bold">
								<div class="font-size-21">MercadoPago</div>
								<div class="font-size-18">
									{{ numeral(getModalValue('mercadopago')).format('$0,0.00') }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="col-md-3 text-center" v-if="modalType == 'pacific'">
					<div class="card bg-warning border-0">
						<div class="card-body">
							<div class="text-white font-weight-bold">
								<div class="font-size-21">Aplazo</div>
								<div class="font-size-18">{{ numeral(paymentMethodsDistribution[modalType]?.paymentMethods?.aplazo?.total).format('$0,0.00') }}</div>
							</div>
						</div>
					</div>
				</div> -->
			</div>
		</a-modal>
	</div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment-timezone'
import numeral from 'numeral'
import ticketComponent from '@/components/ticket'
import _ from 'lodash'
import utilities from '@/services/utilities'
import { mask } from 'vue-the-mask'
import Swal from 'sweetalert2'

const dateFormat = 'YYYY-MM-DD'

export default {
	name: 'posDashboardView',
	components: {
		ticketComponent,
	},
	directives: {
		mask,
	},
	computed: {
		...mapGetters('pos', ['filters']),
		...mapGetters('users', ['usersList']),
		...mapGetters('user', ['user']),
		...mapState(['settings']),
		isSuperAdmin() {
			return [1, 11, 17].includes(this.user.user_id)
		},
		isUserAdmin() {
			return this.user.is_admin ? true : false
		},
		spinnerLoaderLabel() {
			return this.$store.state.pos.spinnerLoaderLabel
		},
		spinnerLoader() {
			return this.$store.state.pos.spinnerLoader
		},
		totalDigital() {
			return (
				this.getNetPaymentMethodValue('credit') +
				this.getNetPaymentMethodValue('credit_msi') +
				this.getNetPaymentMethodValue('debit') +
				this.getNetPaymentMethodValue('mercadopago') +
				this.getNetPaymentMethodValue('paypal') +
				this.getNetPaymentMethodValue('transfer') +
				this.getNetPaymentMethodValue('aplazo')
			)
		},
	},
	watch: {
		'filters.branchOffice': {
			handler(val) {
				if (Array.isArray(val)) {
					if (val.includes(1)) this.selectedBranch = '1'
					else if (val.includes(3)) this.selectedBranch = '3'
					else this.selectedBranch = ''
				}
			},
			immediate: true,
		},
	},
	data() {
		return {
			dashboardGrouped: {},
			canceledTickets: {},
			paymentMethodsDistribution: {},
			filterType: 'day',
			modalDetailDigitalVisible: false,
			modalDetailBoutiqueVisible: false,
			dateFormat,
			columns: [
				{
					title: 'Ticket/Cajero',
					scopedSlots: { customRender: 'id' },
					align: 'center',
					width: '15%',
				},
				{
					title: 'Carrito',
					scopedSlots: { customRender: 'cart' },
					align: 'center',
					width: '50%',
				},
				{
					title: 'Total',
					scopedSlots: { customRender: 'total' },
					align: 'center',
					width: '10%',
				},
				{
					title: 'Fecha',
					scopedSlots: { customRender: 'created_at' },
					align: 'center',
					width: '10%',
				},
				{
					title: 'Info ticket',
					scopedSlots: { customRender: 'action' },
					align: 'right',
					width: '15%',
				},
			],
			ticket: {},
			ticketVisible: false,
			giftTicket: false,
			localClient: {},
			tickets: [],
			totals: {
				panel: 0,
				pacific: 0,
				rls: 0,
				sucursal: {
					1: 0,
					2: 0,
					3: 0,
					4: 0,
				},
				pacific_refacciones: 0,
				pacific_boutique: 0,
				dropshipping: 0,
				shopify: 0,
			},
			selectedBranch: '',
			modalType: 'pacific',
		}
	},
	mounted() {
		this.getData()
		if (this.usersList.length == 0) {
			this.$store.dispatch('users/GET')
		}
	},
	methods: {
		moment,
		numeral,
		getNetPaymentMethodValue(field) {
			if (utilities.objectValidate(this.paymentMethodsDistribution, [this.modalType, 'paymentMethods'], false)) {
				let total = numeral(utilities.objectValidate(this.paymentMethodsDistribution, [this.modalType, 'paymentMethods', field], 0)).value()
				let canceled = numeral(utilities.objectValidate(this.paymentMethodsDistribution, [this.modalType, 'canceled', field], 0)).value()
				return total - canceled
			}
			return 0
		},
		getModalValue(field) {
			if (['refacciones', 'boutique'].includes(this.modalType)) {
				const branchFilter = this.modalType === 'boutique' ? (t) => t.branch_office_id == 4 : (t) => t.branch_office_id != 4
				const tickets = this.tickets.filter((t) => t.active > 0 && t.from_pacific && branchFilter(t))

				const fieldMap = {
					cash: 'payment_cash',
					terminal: 'payment_bank_terminal',
					transfer: 'payment_transfer',
					paypal: 'payment_paypal',
					mercadopago: 'payment_mercadopago',
					aplazo: 'payment_aplazo',
				}

				if (field === 'total') return _.sumBy(tickets, (t) => numeral(t.total).value())

				if (field === 'digital') {
					return _.sumBy(
						tickets,
						(t) =>
							numeral(t.payment_bank_terminal).value() +
							numeral(t.payment_transfer).value() +
							numeral(t.payment_paypal).value() +
							numeral(t.payment_mercadopago).value() +
							numeral(t.payment_aplazo).value(),
					)
				}

				return _.sumBy(tickets, (t) => numeral(t[fieldMap[field]]).value())
			}

			// Lógica original para otros tipos
			if (field === 'total') return this.dashboardGrouped[this.modalType] - this.canceledTickets[this.modalType]
			if (field === 'digital') return this.totalDigital
			return this.getNetPaymentMethodValue(field)
		},
		getRowClass(record) {
			if (record.active < 1) {
				return 'bgRed'
			} else {
				if (record.from_pacific) {
					if (record.salesman_info) {
						return 'bgYellow'
					} else {
						return 'bgGreen'
					}
				}
				if (record.from_panel) {
					return 'bg-purple'
				}
				if (record.from_rls) {
					return 'bgRls'
				}
			}
			return ''
		},
		getTotalBysection(company, branch_office_id) {
			// console.log('getTotalBysection', { company, branch_office_id })
			let ticketsFiltered = []
			let total = 0

			if (Array.isArray(branch_office_id)) {
				ticketsFiltered = this.tickets.filter((e) => (branch_office_id.includes(e.branch_office_id) && company == 's2r' ? e.from_pacific == 1 : e.from_rls == 1))
			} else {
				ticketsFiltered = this.tickets.filter((e) => (e.branch_office_id == branch_office_id && company == 's2r' ? e.from_pacific == 1 : e.from_rls == 1))
			}

			// console.log('ticketsFiltered-->', JSON.stringify(ticketsFiltered))

			total = ticketsFiltered.reduce((previous, current) => {
				console.log('ticket ', { id: current.id, total: current.total })
				return numeral(previous).value() + numeral(current.total).value()
			}, 0)
			return numeral(total).format('$0,0.00')
		},
		getDiscounts(id) {
			let theTicket = this.tickets.find((e) => e.id == id)
			let totalDiscount = 0

			if (utilities.objectValidate(theTicket, 'cart', [])) {
				for (let index = 0; index < theTicket.cart.length; index++) {
					const element = theTicket.cart[index]
					totalDiscount += numeral(utilities.objectValidate(element, 'discount', 0)).value()
				}
			}

			return totalDiscount
		},
		onResetFilter(key) {
			this.$store.dispatch('pos/RESET_ONE_FILTER', key)
			this.initModule()
		},
		onChangePaymentMethod(value) {
			if (value.includes('')) {
				this.filters.paymentMethod = []
			}
			this.initModule()
		},
		onChangeBranchOffice(value) {
			if (value === '') {
				this.filters.branchOffice = []
			} else if (Number(value) == 1) {
				this.filters.branchOffice = [1, 4]
			} else if (Number(value) == 3) {
				this.filters.branchOffice = [3]
			}
			this.initModule()
		},
		initModule(date, dateString) {
			//
			let payload = {}

			if (!!dateString && dateString.length) {
				payload = {
					startDate: moment(dateString[0]).format('YYYY-MM-DD'),
					endDate: moment(dateString[1]).format('YYYY-MM-DD'),
				}
			} else {
				payload = {
					startDate: moment(this.filters.defaultDate[0]).format('YYYY-MM-DD'),
					endDate: moment(this.filters.defaultDate[1]).format('YYYY-MM-DD'),
				}
			}

			if (this.filters.branchOffice.length > 0) {
				payload.branch_office_id = this.filters.branchOffice
			}

			payload = {
				...payload,
				cashier: this.filters.cashier,
				paymentMethod: this.filters.paymentMethod,
			}

			this.tickets = []
			this.dashboardGrouped = {}
			this.paymentMethodsDistribution = {}
			this.canceledTickets = {}

			console.log('payload-->', payload)
			this.$store.dispatch('pos/GET_TICKETS', payload).then((response) => {
				// console.log('GET_TICKETS-->', response)
				this.tickets = _.orderBy(_.cloneDeep(utilities.objectValidate(response, 'tickets', [])), ['created_at'], ['desc'])
				this.dashboardGrouped = _.cloneDeep(utilities.objectValidate(response, 'dashboardGrouped', {}))
				this.paymentMethodsDistribution = _.cloneDeep(utilities.objectValidate(response, 'paymentMethodsDistribution', {}))
				const sumCanceled = (key) => {
					let data = utilities.objectValidate(response, `canceledTickets.${key}`, 0)
					if (Array.isArray(data)) {
						const idSet = new Set(data)
						return this.tickets.reduce((sum, ticket) => (idSet.has(ticket.id) ? sum + numeral(ticket.total).value() : sum), 0)
					}
					return _.cloneDeep(data)
				}

				this.canceledTickets = {
					pacific: sumCanceled('pacific'),
					panel: sumCanceled('panel'),
					rls: sumCanceled('rls'),
				}

				// Actualizamos los totales por sucursal para el tooltip
				this.totals.sucursal[1] = _.sumBy(
					this.tickets.filter((t) => t.branch_office_id == 1 && t.active > 0 && t.from_panel),
					(t) => numeral(t.total).value(),
				)
				this.totals.sucursal[3] = _.sumBy(
					this.tickets.filter((t) => t.branch_office_id == 3 && t.active > 0 && t.from_panel),
					(t) => numeral(t.total).value(),
				)
				this.totals.sucursal[4] = _.sumBy(
					this.tickets.filter((t) => t.branch_office_id == 4 && t.active > 0 && t.from_panel),
					(t) => numeral(t.total).value(),
				)

				// Calculamos totales de Pacific separados
				this.totals.pacific_refacciones = _.sumBy(
					this.tickets.filter((t) => t.branch_office_id != 4 && t.active > 0 && t.from_pacific),
					(t) => numeral(t.total).value(),
				)
				this.totals.pacific_boutique = _.sumBy(
					this.tickets.filter((t) => t.branch_office_id == 4 && t.active > 0 && t.from_pacific),
					(t) => numeral(t.total).value(),
				)
			})

			// Cargamos los datos de dropshipping y Shopify cuando sea general
			if (this.filters.branchOffice.length == 0) {
				this.$store
					.dispatch('pos/GET_DROPSHIPPING_REVENUE', {
						fecha_desde: payload.startDate,
						fecha_hasta: payload.endDate,
					})
					.then((response) => {
						// Actualizamos el total de dropshipping
						this.totals.dropshipping = numeral(utilities.objectValidate(response, 'ingresos_filtrados.ingresos_totales', 0)).value()
					})
					.catch((error) => {
						console.error('Error al obtener ingresos de dropshipping:', error)
					})

				this.$store
					.dispatch('pos/GET_SHOPIFY_REVENUE', {
						fecha_desde: payload.startDate,
						fecha_hasta: payload.endDate,
					})
					.then((response) => {
						// Actualizamos el total de Shopify
						this.totals.shopify = numeral(utilities.objectValidate(response, 'ingresos_filtrados.ingresos_totales', 0)).value()
					})
					.catch((error) => {
						console.error('Error al obtener ingresos de Shopify:', error)
					})
			}
		},
		getData() {
			this.initModule()
		},
		onPrintTicket(record, giftTicket = false) {
			this.giftTicket = giftTicket

			this.ticket = {
				fullName: record.fullName,
				cart: utilities.objectValidate(record, 'cart', false) ? record.cart : [],
				ticketData: {
					id: record.id,
					created_at: record.created_at,
					validator: record.validator,
					branchOfficeId: record.branch_office_id,
				},
				paymentData: {
					payment_bank_terminal: record.payment_bank_terminal,
					payment_cash: record.payment_cash,
					payment_mercadopago: record.payment_mercadopago,
					payment_paypal: record.payment_paypal,
					payment_transfer: record.payment_transfer,
					payment_advance: record.payment_advance,
					payment_billpocket: record.payment_billpocket,
					payment_aplazo: record.payment_aplazo,
				},
				advances: typeof record.advances === 'string' ? JSON.parse(record.advances) : _.cloneDeep(record.advances) || [],
				serviceOrder: numeral(utilities.objectValidate(record, 'service_order', 0)).value(),
				orderDiscount: numeral(utilities.objectValidate(record, 'order_discount', 0)).value(),
			}

			if (utilities.objectValidate(record, 'client', false)) {
				this.localClient = {
					id: record.client,
					client_last_surname: utilities.objectValidate(record, 'client_last_surname', ''),
					client_name: record.client_name,
					client_surname: record.client_surname,
					email: utilities.objectValidate(record, 'email', ''),
					primary_phone: utilities.objectValidate(record, 'primary_phone', ''),
				}
			} else {
				this.localClient = {}
			}

			this.ticketVisible = true

			setTimeout(() => {
				this.$htmlToPaper('reprintPosTicket')
			}, 500)

			setTimeout(() => {
				this.ticketVisible = false
			}, 3000)
		},
		onBillSale(id) {
			this.$store.dispatch('pos/GET_ONE_TICKET', id)
		},
		filterOption(input, option) {
			return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		},
		downloadBill(id) {
			this.$store.dispatch('pos/DOWNLOAD_INVOICE', id)
		},
		searchByTicket() {
			let payload = {
				ticket: this.filters.ticket,
			}

			this.$store.dispatch('pos/GET_TICKETS', payload)
		},
		onResetTicket(e) {
			if (e.target.value == '') {
				this.initModule()
			}
		},
		openModal(modalType) {
			this.modalDetailBoutiqueVisible = true
			this.modalType = modalType
		},
		onCloseModal(modal) {
			switch (modal) {
				case 'digital':
					this.modalDetailDigitalVisible = false
					break
				case 'boutique':
					this.modalDetailBoutiqueVisible = false
					break
			}
		},
		getAdvanceLabel(payload) {
			return JSON.parse(payload)[0].label
		},
		closeAdvance(ticket) {
			Swal.fire({
				title: 'Atención',
				text: '¿Deseas asociar el anticipo a una venta?',
				icon: 'warning',
				showCancelButton: true,
				reverseButtons: true,
				confirmButtonColor: '#41b883',
				confirmButtonText: 'Sí, continuar',
				cancelButtonColor: '#f5222e',
				cancelButtonText: 'No, cancelar',
			}).then(async (result) => {
				if (result.isConfirmed) {
					await Swal.fire({
						title: 'Ingresa # ticket de Pacific',
						input: 'text',
						inputValue: '',
						reverseButtons: true,
						showCancelButton: true,
						confirmButtonColor: '#41b883',
						confirmButtonText: 'Continuar',
						cancelButtonColor: '#f5222e',
						cancelButtonText: 'Cancelar',
						inputValidator: (value) => {
							if (!value) {
								return 'Es necesario ingresar # ticket de Pacific'
							}
						},
					}).then((resConfirm) => {
						if (resConfirm.isConfirmed) {
							//
							this.$store.dispatch('pos/CLOSE_ADVANCE', {
								ticket,
								pacific: resConfirm.value,
							})
						}
					})
				}
			})
		},
	},
}
</script>
